import { render, staticRenderFns } from "./RatingIndicator.vue?vue&type=template&id=0efe6aed"
import script from "./RatingIndicator.vue?vue&type=script&lang=js"
export * from "./RatingIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports